import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CustomerIdCheck from '@components/common/biz/CustomerIdCheck';
import EaHeader from '@components/ea/EaHeader';
import EaBottom from '@components/ea/EaBottom';
import { changeOmniState } from '@store/actions/omniAction';

const AppReportCustomerCheck = props => {
  const {
    fpReport,
    userType,
    // onChangeFpReport,
    onClickNext,
    omniYn,
    isRewrite = false,
    applicationNo,
    isMinor = false,
  } = props;
  const realName = $utils.getRealNameFromFpReport(fpReport, isMinor);
  const [isDisabled, setIsDisabled] = useState(true);
  const [showErrorCheckMsg, setShowErrorCheckMsg] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    // 추후 작성 버튼이 LP 보고서에 없으므로 무조건 false여야함
    if (realName.afterCheckYn) {
      handlerChangeFpReport({ afterCheckYn: false });
    }
  }, []);

  // validation 체크
  const validationCheck = () => {
    let resultData = false;

    // 실명증표확인
    if (realName.checkResult) {
      // 계약자가 미성년자인경우
      if (isMinor) {
        if (realName.custTypeCode === '') {
          resultData = true;
        } else {
          resultData = false;
        }
      } else {
        handlerChangeFpReport({ checkResult: true });
        resultData = false;
      }
    } else {
      handlerChangeFpReport({ checkResult: false });
      resultData = true;
    }

    // 재작성이면 작성완료 활성화
    if (isRewrite) {
      resultData = false;
    }

    setIsDisabled(resultData);
  };

  const handlerChangeFpReport = data => {
    const newRealName = { ...realName, ...data };
    const newFpReport = $utils.addRealNameToFpReport(
      fpReport,
      newRealName,
      isMinor,
    );
    const requestData = { type: 'fpReport', data: newFpReport };

    dispatch(changeOmniState(requestData));
  };

  const handleOnSaveClick = () => {
    // 하단 저장 버튼
    if (isDisabled) {
      setShowErrorCheckMsg(true);
    } else {
      onClickNext();
    }
  };

  return (
    <>
      <EaHeader
        title={`1.${
          $utils.checkLPText(userType)
            ? '라이프파트너 보고서'
            : '보험설계사 보고서'
        }${isRewrite ? ' (재작성)' : ''}${
          isMinor ? '- 친권자 실명증표' : '- 계약자 실명증표'
        }`}
      />

      <div className="con-wrap bg-gray">
        <div className="app-wrap">
          <CustomerIdCheck
            certifyBizKind="26"
            applicationNo={applicationNo}
            certType={realName?.certType}
            issuedDate={realName?.issuedDate}
            authority={realName?.authority}
            foreignAuthority={realName?.foreignAuthority}
            foreignIssuedDate={realName?.foreignIssuedDate}
            collateralNo={realName?.collateralNo}
            licenseNumber={realName?.licenseNumber}
            licenseCode={realName?.licenseCode}
            custTypeCode={realName?.custTypeCode || ''}
            checkResult={realName?.checkResult}
            afterCheckYn={false} // 옴니청약은 실명증표 추후 확인 불가
            showErrorCheckMsg={showErrorCheckMsg}
            isRewrite={isRewrite}
            isMinor={isMinor}
            isVisibleAfterCheck={false}
            isVisibleSubTitle={true}
            isVisibleForeigner={omniYn !== 'Y'} // 옴니청약의 경우 외국인등록증 X
            isVisibleBottomExplanation={true}
            validationCheck={validationCheck}
            onChange={handlerChangeFpReport}
            onChangeMinor={handlerChangeFpReport}
            // onChangeMinor={handlerChangeMinorFpReport}
          />
        </div>
      </div>

      <EaBottom
        label="작성완료"
        onClick={handleOnSaveClick}
        isDisabled={isDisabled}
      />
    </>
  );
};

export default AppReportCustomerCheck;
